var React = require('react');

function FacebookF (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M13.4758 10.9995L13.8908 8.104H11.2968V6.225C11.2968 5.433 11.659 4.6605 12.8209 4.6605H14V2.1955C14 2.1955 12.9301 2 11.9069 2C9.7708 2 8.37461 3.387 8.37461 5.8975V8.1045H6V11H8.37461V18H11.2968V11L13.4758 10.9995Z","fill":"#004EFF"}));
}

FacebookF.defaultProps = {"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none"};

module.exports = FacebookF;

FacebookF.default = FacebookF;
